{
  "AgentDetails_GUID": "(GUID) :",
  "AgentNumber": "Numéro d'agent :",
  "AgentDetails_Partition": "Partition :",
  "AgentDetails_Description": "Description :",
  "AgentDetails_UpdateExistingItems": "Mettre à jour les éléments en double :",
  "AgentDetails_GUIDPlaceholder": "[Auto Assigné]",
  "AgentDetails_Validation_GUID": "La longueur maximale d'un GUID est de 100 caractères",
  "AgentDetails_Validation_AgentNumber": "Un numéro d'agent doit être fourni",
  "AgentDetails_Validation_Partition": "Une partition doit être sélectionnée",
  "AgentDetails_NonePartition": "[Aucun]",
  "NAME": "AgentDetails"
}